import { Asset, AssetState, AssetType } from '@/api/generatedApi';
import { getFileExtension } from '@physna/supported-files';

export type Model = Asset & {
  type: AssetType.Model;
};

export type Image = Asset & {
  type: AssetType.Image;
};

export type Document = Asset & {
  type: AssetType.Document;
};

export const isModel = (asset?: Asset): asset is Model => {
  return asset?.type === AssetType.Model;
};

export const isReadyForCompare = (asset?: Asset): boolean => {
  return asset?.state === AssetState.Finished || asset?.state === AssetState.MissingDependencies;
};

export const isImage = (asset?: Asset): asset is Image => {
  return asset?.type === AssetType.Image;
};

export const isScene = (asset?: Asset): boolean => {
  return asset?.type === AssetType.Scan || asset?.type === AssetType.Scene;
};

export const isDocument = (asset?: Asset): asset is Document => {
  return asset?.type === AssetType.Document;
};

export const isPDFDocument = (asset?: Asset): asset is Document => {
  return asset?.type === AssetType.Document && getFileExtension(asset?.path || '').toLowerCase() === '.pdf';
};

const PLAIN_TEXT_EXTENSIONS = new Set([
  '.txt',
  '.csv',
  '.tsv',
  '.md',
  '.log',
  '.json',
  '.yaml',
  '.yml',
  '.xml',
  '.plmxml',
  '.qif',
]);

export const isTextDocument = (asset?: Asset): asset is Document => {
  return isDocument(asset) && PLAIN_TEXT_EXTENSIONS.has(getFileExtension(asset.path || '').toLowerCase());
};

export const isComparableAsset = (asset?: Asset): boolean => {
  return isModel(asset) || asset?.type === AssetType.Manifest || isTextDocument(asset);
};

export const isSameCompareKind = (asset1?: Asset, asset2?: Asset): boolean => {
  return isTextDocument(asset1) === isTextDocument(asset2);
};
